<template>
  <a
    :href="`items?${receivingKindIdAsUrlParams}`"
    class="receiving-kind__box"
    data-gtm-page="top"
    data-gtm-click="item_receiving_kind"
    :data-gtm-item-receiving-kind-id="receivingKindId"
  >
    <img v-lazy="receivingKindIcon" class="receiving-kind__icon" />
    <div class="receiving-kind__name">
      <span class="minimal-bold">{{ receivingKindName }}</span>
    </div>
  </a>
</template>

<script>
import qs from 'qs'
export default {
  props: {
    receivingKindId: {
      type: Number,
      required: true
    },
    receivingKindName: {
      type: String,
      required: true
    },
    receivingKindIcon: {
      type: String,
      required: true
    }
  },
  computed: {
    receivingKindIdAsUrlParams() {
      const params = { item_receiving_kinds: [this.receivingKindId] }
      return qs.stringify(params, { arrayFormat: 'brackets' })
    }
  }
}
</script>
